import React, { useState, useEffect } from 'react';
import { FileText, Loader2 } from 'lucide-react';

const AuditLogView = ({ entityType, entityId }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (entityType && entityId) {
      fetchLogs();
    }
  }, [entityType, entityId]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await fetch(`/api/admin/audit-logs/${entityType}/${entityId}`, {
        credentials: 'include'
      });
      if (res.ok) {
        const data = await res.json();
        setLogs(data.data || []);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const actionLabels = {
    create: 'Vytvořeno',
    update: 'Upraveno',
    delete: 'Smazáno',
    password_reset: 'Resetování hesla'
  };

  const actionColors = {
    create: { bg: '#E8F5E9', color: '#388E3C' },
    update: { bg: '#E3F2FD', color: '#1976D2' },
    delete: { bg: '#FFEBEE', color: '#E53935' },
    password_reset: { bg: '#FFF3E0', color: '#F57C00' }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
        <Loader2 size={24} className="spin" />
      </div>
    );
  }

  if (logs.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
        <FileText size={32} style={{ margin: '0 auto 12px', opacity: 0.5 }} />
        <p>Žádná historie změn</p>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {logs.map((log) => {
        const ac = actionColors[log.action] || { bg: '#F5F5F5', color: '#666' };
        return (
          <div
            key={log.id}
            style={{
              padding: '16px',
              backgroundColor: '#F9F9F9',
              borderRadius: '10px',
              border: '1px solid #E0E0E0'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
              <div>
                <span
                  style={{
                    fontSize: '12px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    backgroundColor: ac.bg,
                    color: ac.color,
                    fontWeight: 500
                  }}
                >
                  {actionLabels[log.action] || log.action}
                </span>
                <p style={{ fontSize: '14px', fontWeight: 600, color: '#333', margin: '8px 0 4px' }}>
                  {log.username || 'Neznámý uživatel'}
                </p>
              </div>
              <p style={{ fontSize: '12px', color: '#999', margin: 0 }}>
                {new Date(log.created_at).toLocaleString('cs-CZ')}
              </p>
            </div>
            {log.changes && Object.keys(log.changes).length > 0 && (
              <details style={{ fontSize: '13px', color: '#666' }}>
                <summary style={{ cursor: 'pointer', marginTop: '8px' }}>Detaily změn</summary>
                <pre style={{
                  backgroundColor: '#FFF',
                  padding: '12px',
                  borderRadius: '6px',
                  marginTop: '8px',
                  fontSize: '12px',
                  overflow: 'auto'
                }}>
                  {JSON.stringify(log.changes, null, 2)}
                </pre>
              </details>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AuditLogView;
